import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import BusSelect from '../../components/BusSelect';
import { DataContainer } from '../../components/DataContainer';
import { startJob } from '../../store/knownDataSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import DriversListSelector from '../../components/DriversListSelector';
import BusesListSelector from '../../components/BusesListSelector';



function StartJob({ id }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const driverSelectRef = useRef(null);
    const busSelectRef = useRef(null);
    const data = useSelector((state) => state.knownData[id]);

    const [ driver, setDriver ] = useState("");
    const [ extraDrivers, setExtraDrivers ] = useState([]);
    const [ bus, setBus ] = useState("");
    const [ extraBuses, setExtraBuses ] = useState([]);

    async function onStartJob() {
        // Check if extra drivers are unique
        const extraDriversSet = new Set(extraDrivers);
        if(extraDriversSet.size !== extraDrivers.length) {
            toast.error("Korduvad juhid!");
            return;
        }
        if(extraDrivers.includes(driver)) {
            toast.error("Korduvad juhid!");
            return;
        }

        // Check if extra buses are unique
        const extraBusesSet = new Set(extraBuses);
        if(extraBusesSet.size !== extraBuses.length) {
            toast.error("Korduvad bussid!");
            return;
        }
        if(extraBuses.includes(bus)) {
            toast.error("Korduvad bussid!");
            return;
        }



        const res = await unwrapResult(await dispatch(startJob({
            id,
            driver,
            bus,
            extraDrivers,
            extraBuses,
        })));
        if(!res) return;

        navigate("/platform/job/" + id);
        toast.success("Töö loodud!");
    }



    return (
        <DataContainer actionType={"knownData/updateJob"}>
            <div className="column g32">
                <h2>Määra juht ja buss</h2>

                <div className="column g8">
                    <p>Juht</p>
                    <DriversListSelector
                        driver={driver}
                        setDriver={setDriver}
                        extraDrivers={extraDrivers}
                        setExtraDrivers={setExtraDrivers}
                    />
                </div>

                <div className="column g8">
                    <p>Buss</p>
                    <BusesListSelector
                        bus={bus}
                        setBus={setBus}
                        extraBuses={extraBuses}
                        setExtraBuses={setExtraBuses}
                    />
                </div>

                <button onClick={onStartJob}>Salvesta</button>

            </div>
        </DataContainer>
    );
}

export default StartJob;